// extracted by mini-css-extract-plugin
export default {"title":"Contract_title__LXCog","toCenter":"Contract_toCenter__wQ89l","contracts":"Contract_contracts__R9S3j","contract":"Contract_contract__AVZE9"};